import React from 'react';

const sections = [
  {
    title: 'Title Documents',
    items: [
      'Title Deed: The original document that proves ownership of the property.',
      'Sale Deed or Conveyance Deed: Outlines terms of the property transfer.',
      'Chain of Title Documents: All previous ownership documents.'
    ]
  },
  {
    title: 'Encumbrance Documents',
    items: [
      'Encumbrance Certificate: Shows no legal dues on the property.',
      'No Objection Certificate (NOC): From housing society or authority, if applicable.'
    ]
  },
  {
    title: 'Property Tax Documents',
    items: ['Property Tax Receipts: Evidence of tax payments.']
  },
  {
    title: 'Construction and Occupancy Documents',
    items: [
      'Approved Building Plan: Approved by local authority.',
      'Completion Certificate: For newly constructed buildings.',
      'Occupancy Certificate: Confirms readiness for occupation.'
    ]
  },
  {
    title: 'Utility Documents',
    items: ['Latest Electricity and Water Bills: Confirm usage and address.']
  },
  {
    title: 'Owner’s Documents',
    items: [
      'Identity Proof: Aadhaar, PAN, passport, etc.',
      'Address Proof: Aadhaar, utility bill, etc.'
    ]
  },
  {
    title: 'Additional Documents (if applicable)',
    items: [
      'Power of Attorney',
      'NOC from Bank (if under mortgage)',
      'Family Settlement Deed',
      'Death and Succession Certificates',
      'Conversion Certificate (for non-agricultural use)',
      'Lease Deed (if leased)',
      'Mutation Records'
    ]
  },
  {
    title: 'Legal and Regulatory Documents',
    items: [
      'Zoning Regulations',
      'Litigation Documents',
      'Environmental Clearances (if applicable)'
    ]
  },
  {
    title: 'Draft Documents (if applicable)',
    items: ['Draft Sale Deed or Agreement']
  },
  {
    title: 'Legal Checks',
    items: [
      'Title Search',
      'Verification of Documents',
      'Physical Inspection',
      'Review of Local Laws and Zoning'
    ]
  },
  {
    title: 'Additional Information',
    items: [
      'Transaction Details: Sale price, terms, etc.',
      'Purpose of Legal Opinion: Purchase, mortgage, etc.'
    ]
  }
];

const LegalOpinion = () => {
  return (
    <div className="p-6 max-w-5xl mx-auto ">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#333333] mb-10 border-b-2 pb-2 border-[#b7b7a1]">Legal Opinion – Property Document Checklist</h1>
         <p className="text-sm text-justify text-[#444] mb-8">
          Our esteemed fleet of lawyers having a vast experience and guided hundreds of clients to have their dream property in and around Bangalore without any legal obstacles.  Every attorney is specializes in conducting comprehensive legal scrutiny reports tailored to our clients' property transactions. Each attorney brings a wealth of experience in real estate law, ensuring meticulous analysis of titles, encumbrances, zoning regulations, and compliance with local ordinances. Our experts diligently assess the legal standing of properties, identifying any potential risks or disputes that could impact ownership or future transactions. By leveraging their in-depth knowledge and attention to detail, our legal team provides clients with clarity and confidence in their property investments, facilitating smoother transactions and safeguarding their interests. Whether for residential, commercial, or industrial properties, our lawyers are committed to delivering thorough reports that empower customers to make informed decisions.
  </p>
      {sections.map((section, index) => (
        <div key={index} className="mb-6">
          <h2 className="text-xl font-semibold mb-2 border-b border-[#b7b7a1]/30 pb-1">{section.title}</h2>
          <ul className="list-disc pl-6 space-y-1">
            {section.items.map((item, idx) => (
              <li key={idx} className="text-sm">{item}</li>
            ))}
          </ul>
        </div>
      ))}
      <p className="mt-8 text-sm border-t border-[#b7b7a1]/20 pt-4">
        Our legal team ensures a thorough and accurate assessment of the property's legal status by verifying all documents and conducting necessary checks.
      </p>
    </div>
  );
};

export default LegalOpinion;
